<template>
  <div>
      <div class="flexbox details_content">
        <input
          class="file_box"
          type="file"
          accept="image/*"
          @change="customRequest"
          name="file"
          id="file"
        />
        <img
          v-if="idCardUrl === ''"
          src="https://img-cdn1.ylyk.com/image/1665478445565_m1665478362142_s12977.jpg"
        />
        <img v-else :src="idCardUrl" style="border-radius: 20rpx;" />
      </div>
  </div>
</template>

<script>
import { base64ToBlob, compressImg } from '@/utils';
export default {
  data() {
    return {
      idCardUrl: ''
    }
  },
  created() {},

  methods: {
    onScuess(url) {
      this.$emit('onScuess', { url })
    },
    customRequest(e) {
      const file = e.target.files[0]
      console.log(file)
      if (!file) return;
      
      const read = new FileReader()
      read.readAsDataURL(file)
      read.onload = () => {
        compressImg(read.result, 0.9, 1, '仅供友邻认证', (res) => {
          // base64转blob
          const base64 = res.split(',')[1]
          base64ToBlob({ b64data: base64, contentType: 'image/png' }).then(
            (res) => {
              // 转后后的blob对象
              this.customUpload(res)
            }
          )
        })
      }
    },
    customUpload(src) {
      this.$store
        .dispatch('goods/vip/imageTokenH5', {})
        .then((data) => {
          this.$store.dispatch('goods/vip/uploadAliyun', { data, src }).then(res => {
            console.log('身份证地址:', res)
            this.idCardUrl = res;
            this.onScuess(this.idCardUrl)
          })
        })
        .catch((err) => {
          console.log('获取pocily err', err)
          this.idCardUrl = ''
          this.$toast({
            message: '我开小差了，重新传一张吧'
          })
        })
    }
    
  }
}
</script>

<style lang="less" scoped>
.details_box {
  width: 6.86rem;
  background: #ffffff;
  border-radius: 0.16rem;
  margin: 0 auto;
  padding: 0.28rem 0.24rem 3vh;
}
.details_title {
  font-size: 0.32rem;
  font-weight: 600;
  color: #000000;
}
.details_content {
  position: relative;
  width: 6.38rem;
  height: 3.82rem;
  background: #f6f6f6;
  border: 1px dashed rgba(0, 102, 102, 0.8);
  border-radius: 0.16rem;
  margin-top: 0.48rem;
  justify-content: center;
  .file_box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
  }
}

.details_content img {
  display: block;
  width: 5.02rem;
  height: 3.06rem;
}
</style>
